import ContractApprovalDialog from './ContractApprovalDialog';

export default ContractApprovalDialog;
